<template>
  <div class="mr-2 mb-3 flex justify-end">
    <BaseButton
      v-if="$can('manage_invoicing')"
      icon="plus"
      @click="newCheckDeposit"
      :title="$t('button.create_m', { var: $t('global.check_deposit') })"
    />
  </div>

  <BaseContentTable
    v-if="metadata.columns || loading"
    :columns="metadata.columns ?? []"
    :loading="loading"
    :modelList="checkDepositList"
    :search="true"
    @rowClick="redirectToModelPage"
    @refreshClick="withLoading(fetchCheckDepositList())"
    @deleteModel="deleteModelById"
    :isHoverable="true"
  />
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CheckDepositIndex',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      checkDepositList: 'invoicing/getCheckDepositList',
      metadata: 'invoicing/getCheckMetadata'
    })
  },
  methods: {
    ...mapActions({
      fetchCheckDepositList: 'invoicing/fetchCheckDepositList'
    }),
    redirectToModelPage(id) {
      this.$router.push({
        name: 'check_deposit_form_route',
        params: { id: id }
      })
    },
    newCheckDeposit() {
      this.$router.push({
        name: 'check_deposit_form_route',
        params: { id: 'new' }
      })
    },
    deleteModelById() {}
  },
  beforeMount() {
    this.withLoading(this.fetchCheckDepositList())
  }
}
</script>

<style scoped></style>
